export const createCaseSchema = {
  containersData: [
    {
      id: 'case-container-main',
      rowData: [
        {
          id: 'case-row-1',
          isDataRow: true,
          childData: [
            { id: 'fiscalYear',    type: 'Select', label: 'Fiscal Year',   isInfo: true, isMandatory: true },
            { id: 'caseType',      type: 'Select', label: 'Case Type',     isInfo: true, isMandatory: true },
            { id: 'country',       type: 'Select', label: 'Country',       isInfo: true, isMandatory: true },
            { id: 'organization',  type: 'Select', label: 'Organization',  isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'case-row-2',
          isDataRow: true,
          childData: [
            { id: 'title',    type: 'text',   label: 'Title',    isInfo: true, isMandatory: true },
            { id: 'priority', type: 'Select', label: 'Priority', isInfo: true, isMandatory: false },
          ],
        },
        {
          id: 'case-row-3',
          isDataRow: true,
          childData: [
            { id: 'pocName',        type: 'text', label: 'POC Name',         isInfo: true, isMandatory: false },
            { id: 'pocEmail',       type: 'text', label: 'POC Email',        isInfo: true, isMandatory: false },
            { id: 'pocPhoneNumber', type: 'text', label: 'POC Phone Number', isInfo: true, isMandatory: false },
          ],
        },
        {
          id: 'case-row-section',
          isDataRow: true,
          childData: [
            { id: 'sectionEquipment', type: 'SectionHeader', label: 'Equipment Details', isInfo: false, isMandatory: false },
          ],
        },
        {
          id: 'case-row-4',
          isDataRow: true,
          childData: [
            { id: 'equipmentType',       type: 'Select',     label: 'Equipment Type',        isInfo: true, isMandatory: true },
            { id: 'quantity',            type: 'text',       label: 'Quantity',               isInfo: true, isMandatory: true },
            { id: 'specifications',      type: 'text',       label: 'Specifications',         isInfo: true, isMandatory: false },
            { id: 'requiredDeliveryDate',type: 'DatePicker', label: 'Required Delivery Date', isInfo: true, isMandatory: true },
          ],
        },
        {
          id: 'case-row-5',
          isDataRow: true,
          childData: [
            { id: 'description', type: 'Textarea',   label: 'Description', isInfo: true, isMandatory: false },
          ],
        },
        {
          id: 'case-row-6',
          isDataRow: true,
          childData: [
            { id: 'attachments', type: 'uploadfile', label: 'Attachments', isInfo: true, isMandatory: false },
          ],
        },
      ],
    },
  ],
  selectedLayout: {
    'case-row-1':       [3, 3, 3, 3],
    'case-row-2':       [6, 6],
    'case-row-3':       [3, 3, 3],   // fits 3 × col-lg-3 inside the 12-col grid
    'case-row-section': [12],
    'case-row-4':       [3, 3, 3, 3],
    'case-row-5':       [12],
    'case-row-6':       [12],
  },
}
